export default __webpack_public_path__ + "static/media/e864d7cafc71dc3cf840395cf51aea92.c8f1e120.png";